// 设置验证码倒计时
export const USER__SET_CAPTCHA_COUNTDOWN = 'USER__SET_CAPTCHA_COUNTDOWN';
// 设置用户信息
export const USER__SET_USER = 'USER__SET_USER';
// 设置sessionId
export const USER__SET_SESSION_ID = 'USER__SET_SESSION_ID';
